import React, { useEffect, useState } from 'react';
import { UserContext } from 'contexts/user/UserContext';
import { getDiscourseActivationUrl } from 'services/discourseActivation';
import { fetchDiscourseUserChatability } from 'services/discourseChatability';
import { ActivateDiscourseChatButton } from './ActivateDiscourseChat';
import IntlMessages from 'helpers/IntlMessages';

const DiscourseActivationPrompt = (): React.ReactElement | null => {
  const { currentUser, refetchCurrentUser } = React.useContext(UserContext);
  const [statusChecked, setStatusChecked] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const activationUrl = getDiscourseActivationUrl();
  const integrationsDisabled = import.meta.env.VITE_E2E === 'true';

  useEffect(() => {
    let cancelled = false;
    setStatusChecked(false);

    if (
      integrationsDisabled
      || !activationUrl
      || !currentUser?.username
      || !currentUser.isVerified
      || !currentUser.name
      || currentUser.forumActive !== false
      || currentUser.forumSuspended
    ) {
      setStatusChecked(true);
      return;
    }

    fetchDiscourseUserChatability(currentUser.username, true)
      .then((chatable) => {
        if (cancelled) {
          return;
        }
        if (chatable) {
          return refetchCurrentUser();
        }
      })
      .catch((error) => {
        console.warn('Failed to refresh current user Discourse status.', error);
      })
      .finally(() => {
        if (!cancelled) {
          setStatusChecked(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [
    activationUrl,
    integrationsDisabled,
    currentUser?.forumActive,
    currentUser?.forumSuspended,
    currentUser?.isVerified,
    currentUser?.name,
    currentUser?.username,
    refetchCurrentUser,
  ]);

  if (
    integrationsDisabled
    || dismissed
    || !statusChecked
    || !activationUrl
    || !currentUser?.isVerified
    || !currentUser?.name
    || currentUser.forumActive !== false
    || currentUser.forumSuspended
  ) {
    return null;
  }

  return (
    <aside
      className="card shadow-lg p-3 discourse-activation-prompt"
      aria-label="Activate ARK Chat"
      data-testid="discourse-activation-prompt"
    >
      <button
        type="button"
        className="close position-absolute"
        style={{ top: '0.35rem', right: '0.6rem' }}
        aria-label="Close"
        onClick={() => setDismissed(true)}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h2 className="h5 font-weight-bolder text-center mb-3">
        <IntlMessages id="onboarding.chat-title" defaultMessage="Connect with the ARK community" />
      </h2>
      <ActivateDiscourseChatButton className="btn-block" />
    </aside>
  );
};

export default DiscourseActivationPrompt;
